<template>
  <v-row>
    <v-col cols="12">
      <create-forwarder :selection="model" @update="getForwarders" />
    </v-col>

    <v-col cols="12">
      <email-forwarders :pending="pending" @update="getForwarders"/>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import DomainSelect from '@/components/Common/DomainSelect'
import CreateForwarder from './CreateForwarder'
import EmailForwarders from './EmailForwardersTable'

export default {
  name: 'EmailForwarder',
  components: {
    // DomainSelect,
    CreateForwarder,
    EmailForwarders,
  },
  data: () => ({
    domain: '',
    pending: true,
    model: {
      type: 'email',
      subtype: 'fwd'
    }
  }),
  methods: {
    ...mapActions({
      setForwarderDomain: 'email/setForwarderDomain',
      setForwarders: 'email/setForwarders',
      reportError: 'reportError'
    }),
    async getForwarders (payload) {
      this.pending = true
      this.setForwarderDomain(payload)

      try {
        await this.setForwarders({
          domain: this.forwarders.domain,
          _username: this.$route.query.user
        }) // this.forwarders.domain
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    }
  },
  computed: {
    ...mapGetters({
      forwarders: 'email/forwarders'
    })
  },
  created () {
    this.getForwarders()
  },
  watch: {
    domain (val) {
      this.getForwarders(val)
    }
  }
}
</script>
